var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascriptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "javascript-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "javascript-logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.706 0.00183105H3.31209H3.31195C0.509519 0.00186577 0 0.00187206 0 2.5496V115.671C0 120.002 0.25462 120.002 4.07629 120.002H116.809C120.004 120.002 120.004 119.765 120 116.775V116.769C120 116.661 119.999 116.55 119.999 116.435V2.41863C119.999 0.125522 119.999 0.00183105 117.706 0.00183105ZM109.35 63.1866L100.613 69.0465C99.0716 66.7535 95.2172 64.7152 95.2172 64.7152C94.7033 64.4605 93.588 64.4605 92.9045 64.4605C92.1337 64.4605 90.8489 64.7152 90.8489 64.7152C87.2514 65.9891 86.2235 70.8299 90.8487 73.6325L103.697 80.7662C108.836 83.5687 111.009 87.3904 111.663 90.9572C112.317 94.5241 112.433 98.091 110.635 101.403C108.836 104.715 103.183 110.066 98.5575 110.066H93.6754C86.9945 110.066 81.8553 109.556 77.2299 104.46L73.3755 98.8553L82.3691 93.505L86.4804 98.091C90.3348 101.403 97.2727 100.196 99.0715 98.6006C102.669 95.4092 100.613 91.212 99.0715 90.4478L84.1678 82.8044C81.8551 81.5305 78.0009 77.1993 77.2299 74.3968C76.4589 71.5942 76.4591 69.0465 77.2299 65.7344C78.0006 62.4223 83.9111 54.5242 91.6197 54.5242H95.4741C100.099 54.5241 107.551 60.1293 109.35 63.1866ZM52.6537 54.5242H65.2227V95.7015C64.9004 99.8015 61.7904 108.301 51.9286 109.499C49.3906 109.926 43.6621 110.525 41.0516 109.499C37.6677 108.893 30.223 106.119 27.5158 99.8728L37.4259 94.525C37.6736 94.8686 37.9023 95.2131 38.1288 95.5542C39.2654 97.2661 40.3446 98.8917 43.4687 99.8728C44.6773 100.252 47.8632 100.485 49.1489 99.8728C50.72 99.1241 52.6537 97.3059 52.6537 93.9903V54.5242Z",
    fill: "url(#paint0_linear_21_515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_515",
    x1: 1.78344,
    y1: 2.29482,
    x2: 117.452,
    y2: 119.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353714,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5463,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptLogo);
export default __webpack_public_path__ + "static/media/javascript-logo.b9d7b112bf9bd58f894975cc389cee6d.svg";
export { ForwardRef as ReactComponent };